export const ROOT_ROUTE = {
  HOME: 'HOME',
  CASE1: 'CASE1',
  CASE2: 'CASE2',
  CASE3: 'CASE3',
};

export const CASE1_ROUTE = {
  OVERVIEW: 'CASE1_OVERVIEW',
  CHALLENGES: 'CASE1_CHALLENGES',
  BENEFITS: 'CASE1_BENEFITS',
};

export const CASE2_ROUTE = {
  OVERVIEW: 'CASE2_OVERVIEW',
  CHALLENGES: 'CASE2_CHALLENGES',
  BENEFITS: 'CASE2_BENEFITS',
};

export const CASE3_ROUTE = {
  OVERVIEW: 'CASE3_OVERVIEW',
  CHALLENGES: 'CASE3_CHALLENGES',
  BENEFITS: 'CASE3_BENEFITS',
};
